import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import services from '../services';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import { PurchaseAdviceSchemaObject } from '../purchaseAdvice';
import { validateProperty, validate } from "../../Common"
import Joi from '@hapi/joi'
import $ from 'jquery';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { TabPanel } from './tabPanel';
import { ViewOrderListing } from './TabPages/viewOrderListing';
import { AddSupplierListing } from './TabPages/addSupplierListing';
import { ApproveSupplierListing } from './TabPages/approveSupplierListing';
import { WeighmentVerificationListing } from './TabPages/weighmentVerificationListing';
import { OrderCompletionListing } from './TabPages/orderCompletionListing';

const screenCode = 'PURCHASEORDER';

export function PurchaseAdviceListing(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1
        },
        indicator: {
            backgroundColor: '#46B25D',
        }
    }));

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [searchFilter, setSearchFilter] = useState({
        groupID: 0,
        operationEntityID: 0
    });
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
        isNewPurchaseOrderTabEnabled: false,
        isViewSupplierVerifyTabEnabled: false,
        isViewWeighmentVerfiyTabEnabled: false,
        isViewOrderCompletionTabEnabled: false,
        isViewAllOrdersTabEnabled: false,
    });

    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    useEffect(() => {

        var res = localStorage.getItem('value');

        if (res !== null) {
            setValue(parseInt(res));
        } else {
            setValue(0);
        }

        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getCompanies()
        )
    }, [searchFilter.groupID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPURCHASEORDERSCREEN');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITPURCHASEORDERS');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        var isNewPurchaseOrderTabEnabled = permissions.find(p => p.permissionCode == 'VIEWNEWPURCHASEORDERS');
        var isViewSupplierVerifyTabEnabled = permissions.find(p => p.permissionCode == 'VIEWSUPPLIERVERIFY');
        var isViewWeighmentVerfiyTabEnabled = permissions.find(p => p.permissionCode == 'VIEWWEIGNMENTVERIFY');
        var isViewOrderCompletionTabEnabled = permissions.find(p => p.permissionCode == 'VIEWORDERCOMPLETION');
        var isViewAllOrdersTabEnabled = permissions.find(p => p.permissionCode == 'VIEWALLPURCHASEORDERS');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled != undefined,
            
            isNewPurchaseOrderTabEnabled: isNewPurchaseOrderTabEnabled != undefined,
            isViewSupplierVerifyTabEnabled: isViewSupplierVerifyTabEnabled != undefined,
            isViewWeighmentVerfiyTabEnabled: isViewWeighmentVerfiyTabEnabled != undefined,
            isViewOrderCompletionTabEnabled: isViewOrderCompletionTabEnabled != undefined,
            isViewAllOrdersTabEnabled: isViewAllOrdersTabEnabled != undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchFilter({
            ...searchFilter,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getCompanies() {
        const companies = await services.getMultiCropsByGroupID(searchFilter.groupID);
        setOperationEntity(companies);
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {

        const target = e.target

        const value = target.name === 'isActive' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, PurchaseAdviceSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchFilter({
            ...searchFilter,
            [e.target.name]: value
        })
        setErrors(error)
    }

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
        localStorage.setItem('value', newValue);
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Order Management"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Orders"
                            path="PurchaseAdvice/AddEdit" />
                        <div className="card-body pb-4">
                            <div className="form-group row pb-2">
                                <div className="col-md-4">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchFilter.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <span id="errbranchCode" className="text text-danger">{errors["groupID"]}</span>}
                                </div>
                                <div className="col-md-4">
                                    <InputLabel shrink id="operationEntityID">Company *</InputLabel>
                                    <Select fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchFilter.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Company--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <span id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</span>}
                                </div>
                            </div>
                        </div>
                        <div className={classes.root}>
                            <AppBar position="static">
                                <Tabs value={value} onChange={handleTabChange} classes={{ indicator: classes.indicator }}
                                    aria-label="simple tabs example" style={{ backgroundColor: "white" }}>
                                    {permissionList.isNewPurchaseOrderTabEnabled ? <Tab label="Add Supplier" {...a11yProps(0)} style={{ color: "black" }}/> : <Tab hidden={true} label="Add Supplier" {...a11yProps(0)} style={{ color: "black" }}/>}                                  
                                    {permissionList.isViewSupplierVerifyTabEnabled ? <Tab label="Supplier Verify" {...a11yProps(1)} style={{ color: "black" }}/> : <Tab hidden={true} label="Supplier Verify" {...a11yProps(1)} style={{ color: "black" }}/>}
                                    {permissionList.isViewWeighmentVerfiyTabEnabled ? <Tab label="Weignment Verification" {...a11yProps(2)} style={{ color: "black" }}/> : <Tab hidden={true} label="Weignment Verification" {...a11yProps(2)} style={{ color: "black" }}/>}
                                    {permissionList.isViewOrderCompletionTabEnabled ? <Tab label="Order Completion" {...a11yProps(3)} style={{ color: "black" }}/> : <Tab hidden={true} label="Order Completion" {...a11yProps(3)} style={{ color: "black" }}/>}
                                    {permissionList.isViewAllOrdersTabEnabled ? <Tab label="View Orders" {...a11yProps(4)} style={{ color: "black" }}/> : <Tab hidden={true} label="View Orders" {...a11yProps(4)} style={{ color: "black" }}/>}
                                </Tabs>
                            </AppBar>
                            {permissionList.isNewPurchaseOrderTabEnabled ? <TabPanel value={value} index={0}>
                                <AddSupplierListing searchData={searchFilter} permission={permissionList.isAddEditEnabled} />
                            </TabPanel> : null}
                            {permissionList.isViewSupplierVerifyTabEnabled ?<TabPanel value={value} index={1}>
                                <ApproveSupplierListing searchData={searchFilter} permission={permissionList.isAddEditEnabled} />
                            </TabPanel> : null}
                            {permissionList.isViewWeighmentVerfiyTabEnabled ? <TabPanel value={value} index={2}>
                                <WeighmentVerificationListing searchData={searchFilter} permission={permissionList.isAddEditEnabled} />
                            </TabPanel> : null}
                            {permissionList.isViewOrderCompletionTabEnabled ? <TabPanel value={value} index={3}>
                                <OrderCompletionListing searchData={searchFilter} permission={permissionList.isAddEditEnabled} />
                            </TabPanel> : null}
                            {permissionList.isViewAllOrdersTabEnabled ? <TabPanel value={value} index={4}>
                                <ViewOrderListing searchData={searchFilter} permission={permissionList.isAddEditEnabled} />
                            </TabPanel> : null}
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}